import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './auth-context';
import Login from './pages/Login';
import ChecklistsPage from './pages/ChecklistsPage';
import ChecklistDetailPage from './pages/ChecklistDetailPage';
import TrainingPage from './pages/TrainingPage';
import TrainingDetailPage from './pages/TrainingDetailPage';
import FailuresPage from './pages/FailuresPage';
import Layout from './components/Layout';

export default function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="splash">
        <div className="splash__spinner" />
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/checklists" replace />} />
        <Route path="/checklists" element={<ChecklistsPage />} />
        <Route path="/checklists/:id" element={<ChecklistDetailPage />} />
        <Route path="/training" element={<TrainingPage />} />
        <Route path="/training/:id" element={<TrainingDetailPage />} />
        <Route path="/failures" element={<FailuresPage />} />
        <Route path="*" element={<Navigate to="/checklists" replace />} />
      </Routes>
    </Layout>
  );
}
